<script lang="ts">
  import { getModalStore } from '@skeletonlabs/skeleton';

  const modalStore = getModalStore();
  export let parent: any;

  const onConfirm = $modalStore[0]?.meta?.onConfirm;
  const entityName = $modalStore[0]?.meta?.entityName || 'All entities';
  const syncTypeName = $modalStore[0]?.meta?.syncTypeName || 'All types';

  function handleConfirm() {
    if (onConfirm) {
      onConfirm();
    }
    modalStore.close();
  }

  function handleCancel() {
    modalStore.close();
  }
</script>

{#if $modalStore[0]}
  <div class="card p-6 max-w-md w-modal">
    <h3 class="h3 mb-4 text-warning-600">Confirm Force Sync</h3>
    
    <div class="space-y-3 mb-6">
      <p class="text-base">
        Are you sure you want to force a sync for this client?
      </p>
      
      <div class="rounded-lg bg-surface-200 border border-surface-400 p-3">
        <p class="text-sm font-semibold mb-2">Selected scope:</p>
        <ul class="text-sm space-y-1 ml-4">
          <li><span class="font-medium">Entity:</span> {entityName}</li>
          <li><span class="font-medium">Sync Type:</span> {syncTypeName}</li>
        </ul>
      </div>
      
      <div class="rounded-lg bg-warning-50 border border-warning-200 p-3">
        <p class="text-sm text-warning-800 font-semibold mb-2">⚠️ This action will:</p>
        <ul class="text-sm text-warning-700 space-y-1 ml-4 list-disc">
          <li>Reset the LastRun timestamp for the selected integration(s)</li>
          <li>Trigger a full data resync on the next scheduled run</li>
          <li>Potentially process a large volume of data</li>
        </ul>
      </div>
    </div>

    <div class="flex justify-end space-x-2">
      <button
        type="button"
        class="btn variant-ghost-surface"
        on:click={handleCancel}
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn variant-filled-warning"
        on:click={handleConfirm}
      >
        Confirm Force Sync
      </button>
    </div>
  </div>
{/if}
